import type { GenerateRequest, GenerationJob } from '@studio/contract';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useStudioClient } from '../context';
import { parseApiError } from '../errors';

/**
 * `POST /api/generate` — kicks a stub generation. v0 returns a synchronous
 * GenerationJob with status=COMPLETED and a placehold.co URL. The wire shape
 * is the legacy `GenerationJob`; real AI integration swaps the
 * outputImageUrl source without changing this hook.
 *
 * On success, invalidates `['generations']` so the Gallery + Studio recent
 * drafts strip refetch and surface the new job.
 */
export function useGenerate() {
  const client = useStudioClient();
  const qc = useQueryClient();
  return useMutation<GenerationJob, Error, GenerateRequest>({
    mutationFn: async (body) => {
      const res = await client.api.generate.$post({ json: body });
      if (!res.ok) throw await parseApiError(res);
      return (await res.json()) as GenerationJob;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['generations'] });
    },
  });
}
